import {
    IDynamicLinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { amazonS3Metadata } from 'app/registries/linked-service/amazon-s3-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { CommonResourceKind as ResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { cdcDestination } from 'app/registries/consts/metadata-consts';

export const sapDatasphereForAmazonS3Metadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata = await amazonS3Metadata(injector);
    return {
        ...metadata,
        disabled: !__IS_FABRIC_DPE__,
        type: adfModelTypeMap.sapDatasphereForAmazonS3.linkedServiceType,
        displayName: stringResources.SapDatasphereForAmazonS3LinkedService_DisplayText,
        icon: {
            className: 'svg-i-100x100-Sap'
        },
        copySourceTypes: [],
        copySinkTypes: [],
        supportedJobModesAsSource: ['CDC'],
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'SAPDatasphereAmazonS3' as ResourceKind
        },
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        supportCopyJobSource: true,
        supportCopyJobSink: false,
        nativeCDCOnly: true,
        cdc: {
            supportCDC: true,
            supportedCDCDestinations: cdcDestination,
            GA: true
        },
        supportDatasetV2: true,
        linkedServiceNamePrefix: 'SAPAmazonS3',
        supportFirstClassParameterExperience: false,
        controls: [],
        notSupportCopySink: true,
        notSupportDeleteActivity: true,
        supportGetMetadataActivity: false,
        supportStoredProcedureActivity: false,
        supportScriptActivity: false,
        supportAutoFillCopilotInput: false,
        isKnownInPipelineContext: false
    }
}
